import * as api from '../api.service';

const upload = async (data: any, file:File) => {
  const formData = new window.FormData();
  let fileSize = 0;
  const hash = sessionStorage.getItem('access_token');
  const requestHeaders = {
    'Content-Type': 'multipart/form-data',
    Accept: '*/*',
    'X-File-Size': 0,
    Authorization: hash,
  };
  formData.append('UploadDocumentRequest', JSON.stringify(data));
  formData.append('file', file);
  fileSize = file.size;
  requestHeaders['X-File-Size'] = fileSize;
  const requestConfig = {
    headers: requestHeaders,
  };
  const response = await api.uploadApi(`${process.env.REACT_APP_API_URL}/documents/upload`, formData, requestConfig);
  return response;
};

const deleteFile = async (data:any) => {
  const response = await api.deleteData(`${process.env.REACT_APP_API_URL}/documents/files/${data}`);
  return response;
};

const DocumentUploadService = {
  upload,
  deleteFile,
};

export default DocumentUploadService;
